import SliceListProvider from "../../../../Common/SliceListProvider";
import List from "./List";

type Props = {
  pageClaims: any;
  viewAmendmentDetail: any;
  reloadPending: boolean;
  reloadCompleted: () => void;
};

const PendingGeneralAmendments = ({
  pageClaims,
  viewAmendmentDetail,
  reloadPending,
  reloadCompleted,
}: Props) => (
  <SliceListProvider>
    <List
      pageClaims={pageClaims}
      viewAmendmentDetail={viewAmendmentDetail}
      reloadPending={reloadPending}
      reloadCompleted={reloadCompleted}
    />
  </SliceListProvider>
);

export default PendingGeneralAmendments;
